"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MissedPayment {
}
exports.default = MissedPayment;
//# sourceMappingURL=MissedPayment.js.map